<template>
  <div style="margin-top: 0px">
    <div class="QRCode" style="text-align: center">
      <canvas :id="canvasId" :style="{ width: 150, height: 150 }"></canvas>
    </div>
    <div>请出示二维码给客户扫码评价</div>
  </div>
</template>
<script>
import QRCode from "qrcode";
export default {
  name: "task_commentqrcode",
  components: {},
  data() {
    return {
      canvasId: "",
      data: {},
    };
  },
  methods: {
    async showInfo(id) {
      this.canvasId = this.getUUID();
      let width = 150,
        height = 150;
      this.$nextTick(() => {
        var that = this;
        QRCode.toCanvas(
          document.getElementById(that.canvasId),
          "https://paiche.hbgcjc.com/task_customer?id=" + id,
          { width, height, toSJISFunc: QRCode.toSJIS },
          (error) => {
            console.log("error" + error);
          }
        );
      });
    },
    getUUID() {
      let d = new Date().getTime();
      let uuid = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
        /[xy]/g,
        function (c) {
          let r = (d + Math.random() * 16) % 16 | 0;
          d = Math.floor(d / 16);
          return (c == "x" ? r : (r & 0x7) | 0x8).toString(16);
        }
      );
      return uuid;
    },
  },
};
</script>
<style scoped>
.item {
  display: flex;
  align-items: center;
  min-height: 40px;
}
.item .lft {
  text-align: left;
  min-width: 80px;
}
.item .cnt {
  text-align: left;
}
</style>
